var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pu_subTitle01"},[_c('article',{staticClass:"pu_wd_def_max"},[_c('h2',{staticClass:"dev_inc_title"},[_vm._v(_vm._s(_vm.getBase.userMenuName_3d))]),_c('p',{staticClass:"dev_inc_title_sub"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }